/**
 * @file Facet Filters.
 */

/* global FWP */

/**
 * Facet Filters component.
 */
const vFacetFilters = () => {
	const facetFilters = document.querySelectorAll('.facetwp-facet');

	if (!facetFilters.length || !window.FWP) {
		return;
	}

	/**
	 * Set up dropdown within a facet filter.
	 * @param {HTMLElement} facetFilter - Facet filter element.
	 */
	const initDropdown = (facetFilter) => {
		const { dropdownLabel, dropdownInstruction } = facetFilter.dataset;
		const dropdown = facetFilter.querySelector('.v-dropdown');
		if (dropdown && dropdownLabel) {
			const label = facetFilter.querySelector('.v-dropdown__label');
			const title = facetFilter.querySelector('.v-dropdown__title-text');
			const currentValue = dropdown.querySelector(
				'.v-dropdown__button--selected',
			).dataset.value;

			if (!currentValue) {
				label.innerText = dropdownLabel;
			}
			title.innerText = dropdownInstruction;
			label.setAttribute('data-default', dropdownLabel);
		}
	};

	/**
	 * Set up facet filters.
	 */
	const facetFilterSetup = () => {
		[...facetFilters].forEach((facetFilter) => {
			const { type } = facetFilter.dataset;
			if (type === 'dropdown') {
				initDropdown(facetFilter);

				const facet = facetFilter.querySelector('.facetwp-dropdown');
				if (facet) {
					facet.addEventListener('change', () => {
						FWP.refresh();
					});
				}
			} else if (type === 'radio') {
				initDropdown(facetFilter);

				const radioWrap = facetFilter.querySelector(
					'.v-facet-filters__radio-list',
				);
				const dropdown = facetFilter.querySelector('.v-dropdown');
				radioWrap.addEventListener('change', () => {
					if (getComputedStyle(dropdown).display === 'none') return;

					const radios = radioWrap.querySelectorAll('[type="radio"]');
					[...radios].forEach((radio) => {
						if (radio.checked) {
							radio.classList.add('checked');
						} else {
							radio.classList.remove('checked');
						}
					});
					FWP.refresh();
				});
			}
		});
	};

	document.addEventListener('facetwp-loaded', facetFilterSetup);
	if (FWP.loaded) {
		facetFilterSetup();
	}
};

export default vFacetFilters;
